"use client";
import React, { createContext, useContext } from 'react';

// Create context for editor state
interface EditorContextType {
  namespace: string;
}

const EditorContext = createContext<EditorContextType | undefined>(undefined);

const EditorProvider: React.FC<{
  children: React.ReactNode;
  namespace: string;
}> = ({ children, namespace }) => {
  return (
    <EditorContext.Provider value={{
      namespace
    }}>
      {children}
    </EditorContext.Provider>
  );
};

const useEditor = () => {
  const context = useContext(EditorContext);
  if (!context) {
    throw new Error('useEditor must be used within an EditorProvider');
  }
  return context;
};

export { EditorProvider, useEditor };
